import { render } from "./ResetPwResetToken.vue?vue&type=template&id=51791040&ts=true"
import script from "./ResetPwResetToken.vue?vue&type=script&lang=ts"
export * from "./ResetPwResetToken.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\nyffeler\\IdeaProjects\\data_tools\\Branches\\data_tools\\131\\frontend-vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__